import * as yup from "yup";
import { createValidationSchema, validate } from "@";

// Define the validation schema for the form
export const schema = createValidationSchema({
  title: validate("req", "title"),
  order: validate("number", "Order"),
  mediaType: validate("number", "MediaType"),
  file: yup.string().when(["mediaType", "fileUrl"], {
    is: (mediaType, fileUrl) => mediaType === 0 && !fileUrl,
    then: () => validate("image", "image"),
    otherwise: () =>
      yup.string().when(["mediaType", "fileUrl"], {
        is: (mediaType, fileUrl) => mediaType === 1 && !fileUrl,
        then: () => validate("req", "video"),
        otherwise: () => yup.string().nullable(),
      }),
  }),
});

// Define the default values for the form fields
export const defaultValues = {
  id: null,
  order: 0,
  title: null,
  mediaType: "0",
  file: null,
  fileUrl: null,
  isActive: true,
};
